import { fromJS } from 'immutable';
import * as _ from 'lodash';
import base64 from 'base-64';

import { SUCCESS, START, ERROR } from '@modules/appraisal/actions/global';
import * as appealsActions from '../actions/appeals';
import { fetchingState } from '@constants';

const updateStateArrayItem = (state, action, arrayName, idFieldName) =>
  state.setIn(
    [arrayName, 'data'],
    fromJS(
      state
        .getIn([arrayName, 'data'])
        .toJS()
        .map((x) =>
          x[idFieldName] === _.get(action, `data.results[0].${idFieldName}`)
            ? action.data.results[0]
            : x,
        ),
    ),
  );

const initialAppealConfiguration = {
  useConferencing: 0,
  useWaitingRoom: 0,
};

const initialState = {
  appealConfiguration: {
    data: initialAppealConfiguration,
    state: null,
  },
  appealsSearch: { data: [], state: null },
  searchModifier: null,
  appealsSearchLastPayload: { data: {}, state: null },
  searchConfigResults: { data: [], state: null },
  lastSearch: {},
  pagination: {
    count: 0,
    page: 1,
    rowsPerPage: 10000,
    rowsPerPageOptions: [5, 10, 25, 50, 1000, 5000, 10000],
  },
  codeFiles: { data: {}, state: null },
  appraisers: { data: [], state: null },
  users: { data: [], state: null },
  appealsHeader: { data: {}, state: null },
  appealsSummary: { data: {}, state: null },
  appealGeneralInfo: { data: {}, state: null },
  appealReasons: { data: {}, state: null },
  appealTags: { data: {}, state: null },
  claimant: { data: {}, state: null },
  affidavits: { data: {}, state: null },
  dueDiligence: { data: {}, state: null },
  informal: { data: {}, state: null },
  priorYrComments: { data: {}, state: null },
  formal: { data: {}, state: null },
  finalValues: { data: {}, state: null },
  globalDocuments: { data: [], state: null },
  presentationDocuments: { data: [], state: null },
  appealPresentation: { data: {}, state: null },
  appealStaff: { data: [], state: null },
  appealDocuments: { data: [], state: null },
  appealDocFiles: { data: [], state: null },
  newInsertedAppeal: { data: {}, state: null },
  casePrep: { data: {}, state: null },
  panels: { data: [], state: null },
  panel: { data: {}, state: null },
  panelBoardMembers: { data: [], state: null },
  panelBoardMember: { data: {}, state: null },
  activity: { data: [], state: null },
  appealBoardMembers: { data: [], state: null },
  appealBoardMember: { data: {}, state: null },
  codeFileOfficerPositions: { data: [], state: null },
  codeFileRoles: { data: [], state: null },
  codeFilePreferredCommunication: { data: [], state: null },
  panelRoles: { data: [], state: null },
  appealStaffRoles: { data: [], state: null },
  appealPanelCadStaffs: { data: [], state: null },
  appealPanelCadStaff: { data: {}, state: null },
  appealDecisionAuthority: { data: [], state: null },
  appealDecisionCode: { data: [], state: null },
  appealDecisionReason: { data: [], state: null },
  appealsStatistics: { data: {}, state: null },
  searchParams: {
    data: [],
    state: null,
  },
  searchParam: {
    data: {},
    state: null,
  },
  appealRecommendations: { data: [], state: null },
  recommendationValues: { data: [], state: null },
  appealRecommendation: { data: {}, state: null },
  printCard: { data: null, state: null },
  appealsUpdateConfig: { data: {}, state: null },
  statusCodes: { data: [], state: null },
  appealStatusConfigState: { data: [], state: null },
  appealModuleReports: { data: [], state: null },
  appealStatus: { data: {}, state: null },
  finalLetterHistory: { data: [], totalRecords: 0, state: null },
  massFinalizeHistory: { data: [], totalRecords: 0, state: null },
  massProcessHistory: { data: [], totalRecords: 0, state: null },
  massProcessHistoryPropertyList: { data: [], totalRecords: 0, state: null },
  massProcessHistoryErrors: { data: [], totalRecords: 0, state: null },
  massProcessEntries: { data: [], state: null },
  massAppealLetterHistory: { data: [], totalRecords: 0, state: null },
  massAttachHistory: { data: [], totalRecords: 0, state: null },
  evidenceUploadHistory: { data: [], totalRecords: 0, state: null },
  evidenceImportProperties: { data: [], state: null },
  massDownloadHistory: { data: [], totalRecords: 0, state: null },
  massAoaHistory: { data: [], totalRecords: 0, state: null },
  massProperties: { data: [], state: null },
  autoPacketStatus: { data: [], state: null },
  events: { data: [], state: null },
  taxingUnits: [],
  incomeActual: { data: {}, state: null },
  incomeModel: { data: {}, state: null },
  currentAppealYear: 2022,
  panelDocketGroups: { data: [], state: null },
  panelWaitingRooms: { data: [], state: null },
  appealSearchFormData: {},
  selectedInformalWaitingRoom: null,
  selectedFormalWaitingRoom: null,
  selectedPanelType: null,
  formalVCRecordings: { data: [], state: null },
  panelStatistics: {
    data: [],
    state: null,
    parameters: { beginDate: null, endDate: null, mode: 0, modeOptions: {} },
  },
};

export default (state = fromJS(initialState), action) => {
  switch (action.type) {
    case appealsActions.FETCH_CURRENT_APPEAL_YEAR[SUCCESS]: {
      return state.set(
        'currentAppealYear',
        action.data.results.currAppealYear.toString(),
      );
    }
    case appealsActions.GET_APPEAL_INCOME_ACTUAL[ERROR]: {
      return state.setIn(['incomeActual', 'state'], fetchingState.ERROR);
    }
    case appealsActions.GET_APPEAL_INCOME_ACTUAL[START]: {
      return state.setIn(['incomeActual', 'state'], fetchingState.FETCHING);
    }
    case appealsActions.GET_APPEAL_INCOME_ACTUAL[SUCCESS]: {
      return state
        .setIn(['incomeActual', 'state'], fetchingState.LOADED)
        .setIn(
          ['incomeActual', 'data'],
          fromJS(_.get(action, 'data.results[0]', {})),
        );
    }
    case appealsActions.GET_APPEAL_INCOME_MODEL[ERROR]: {
      return state.setIn(['incomeModel', 'state'], fetchingState.ERROR);
    }
    case appealsActions.GET_APPEAL_INCOME_MODEL[START]: {
      return state.setIn(['incomeModel', 'state'], fetchingState.FETCHING);
    }
    case appealsActions.GET_APPEAL_INCOME_MODEL[SUCCESS]: {
      return state
        .setIn(['incomeModel', 'state'], fetchingState.LOADED)
        .setIn(
          ['incomeModel', 'data'],
          fromJS(_.get(action, 'data.results[0]', {})),
        );
    }
    case appealsActions.SET_SEARCH_MODIFIER:
      return state.setIn(['searchModifier'], action.data);
    case appealsActions.SET_LAST_SEARCH:
      return state.setIn(['lastSearch'], action.data);
    case appealsActions.FETCH_APPEALS_UPDATE_CONFIG[START]: {
      return state.setIn(
        ['appealsUpdateConfig', 'state'],
        fetchingState.FETCHING,
      );
    }
    case appealsActions.FETCH_APPEALS_UPDATE_CONFIG[SUCCESS]: {
      return state
        .setIn(['appealsUpdateConfig', 'state'], fetchingState.LOADED)
        .setIn(
          ['appealsUpdateConfig', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        );
    }
    case appealsActions.DELETE_PRESENTATION_DOCUMENTS[SUCCESS]: {
      return state
        .setIn(['presentationDocuments', 'state'], fetchingState.LOADED)
        .setIn(['presentationDocuments', 'data'], fromJS([]));
    }
    case appealsActions.FETCH_APPEAL_PANEL_STATISTICS[START]: {
      return state
        .setIn(['panelStatistics', 'state'], fetchingState.FETCHING)
        .setIn(['panelStatistics', 'parameters'], {
          beginDate: action.beginDate ? action.beginDate : null,
          endDate: action.endDate ? action.endDate : null,
          mode: action.mode ? action.mode : 0,
          modeOptions: action.modeOptions ? action.modeOptions : {},
        });
    }
    case appealsActions.FETCH_APPEAL_PANEL_STATISTICS[SUCCESS]: {
      return state
        .setIn(['panelStatistics', 'state'], fetchingState.LOADED)
        .setIn(
          ['panelStatistics', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        );
    }
    case appealsActions.SET_PANEL_STATISTICS_MODE: {
      const parameterData = state.getIn(['panelStatistics', 'parameters']);
      const newData = {
        ...parameterData,
        mode: action.payload.mode,
        modeOptions: action.payload.modeOptions
          ? action.payload.modeOptions
          : parameterData.modeOptions,
      };
      return state.setIn(['panelStatistics', 'parameters'], newData);
    }
    case appealsActions.FETCH_APPEAL_PANEL_STATISTICS[ERROR]: {
      return state.setIn(['panelStatistics', 'state'], fetchingState.ERROR);
    }
    case appealsActions.FETCH_APPEALS_UPDATE_CONFIG[ERROR]: {
      return state.setIn(['appealsUpdateConfig', 'state'], fetchingState.ERROR);
    }
    case appealsActions.FETCH_STATISTICS[START]: {
      return state.setIn(
        ['appealsStatistics', 'state'],
        fetchingState.FETCHING,
      );
    }
    case appealsActions.FETCH_STATISTICS[SUCCESS]: {
      return state
        .setIn(['appealsStatistics', 'state'], fetchingState.LOADED)
        .setIn(
          ['appealsStatistics', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        );
    }
    case appealsActions.CLEAR_FORMAL_HEARING_DATE[SUCCESS]: {
      let updatedState = state.getIn(['formal', 'data']).toJS();
      updatedState.docketID = null;
      updatedState.docketDt = null;
      updatedState.docketTimeSlotID = null;
      updatedState.docketEndTime = null;
      updatedState.docketStartTime = null;
      updatedState.reservationID = null;
      return state.setIn(['formal', 'data'], fromJS(updatedState));
    }
    case appealsActions.CLEAR_FORMAL_ARRIVAL_TIME[SUCCESS]: {
      let updatedState = state.getIn(['formal', 'data']).toJS();
      updatedState.formalArrivalTime = null;
      return state.setIn(['formal', 'data'], fromJS(updatedState));
    }
    case appealsActions.CLEAR_INFORMAL_HEARING_DATE[SUCCESS]: {
      let updatedState = state.getIn(['informal', 'data']).toJS();
      updatedState.informalDocketID = null;
      updatedState.informalDocketDt = null;
      updatedState.informalDocketTimeSlotID = null;
      updatedState.informalDocketEndTime = null;
      updatedState.informalDocketStartTime = null;
      updatedState.informalReservationID = null;
      return state.setIn(['informal', 'data'], fromJS(updatedState));
    }
    case appealsActions.CLEAR_INFORMAL_ARRIVAL_TIME[SUCCESS]: {
      let updatedState = state.getIn(['informal', 'data']).toJS();
      updatedState.informalArrivalTime = null;
      return state.setIn(['informal', 'data'], fromJS(updatedState));
    }
    case appealsActions.FETCH_STATISTICS[ERROR]: {
      return state.setIn(['appealsStatistics', 'state'], fetchingState.ERROR);
    }
    case appealsActions.SEARCH_APPEALS[START]: {
      return state
        .setIn(['appealsSearch', 'state'], fetchingState.FETCHING)
        .setIn(['pagination', 'page'], action.page)
        .setIn(['pagination', 'rowsPerPage'], action.pageSize);
    }
    case appealsActions.SEARCH_APPEALS[SUCCESS]: {
      return state
        .setIn(['appealsSearch', 'state'], fetchingState.LOADED)
        .setIn(
          ['appealsSearchLastPayload', 'data'],
          fromJS(_.get(action, 'payload', {})),
        )
        .setIn(
          ['appealsSearch', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        )
        .setIn(['pagination', 'count'], _.get(action, 'data.totalAppeals', 0));
    }
    case appealsActions.SEARCH_APPEALS[ERROR]: {
      return state.setIn(['appealsSearch', 'state'], fetchingState.ERROR);
    }

    case appealsActions.FETCH_SEARCH_RESULTS_CONFIG[START]: {
      return state.setIn(
        ['searchConfigResults', 'state'],
        fetchingState.FETCHING,
      );
    }
    case appealsActions.FETCH_SEARCH_RESULTS_CONFIG[SUCCESS]: {
      return state
        .setIn(['searchConfigResults', 'state'], fetchingState.LOADED)
        .setIn(
          ['searchConfigResults', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        );
    }
    case appealsActions.FETCH_SEARCH_RESULTS_CONFIG[ERROR]: {
      return state.setIn(['searchConfigResults', 'state'], fetchingState.ERROR);
    }

    case appealsActions.CHANGE_PAGE: {
      return state.setIn(['pagination', 'page'], action.payload);
    }
    case appealsActions.CHANGE_ROWS_PER_PAGE: {
      return state.setIn(['pagination', 'rowsPerPage'], action.payload);
    }

    case appealsActions.FETCH_CODE_FILE[SUCCESS]:
      return state.setIn(
        ['codeFiles', 'data', action.name],
        fromJS(action.data ? action.data.results : []),
      );

    case appealsActions.FETCH_APPRAISERS[START]: {
      return state.setIn(['appraisers', 'state'], fetchingState.FETCHING);
    }
    case appealsActions.FETCH_APPRAISERS[SUCCESS]: {
      return state
        .setIn(['appraisers', 'state'], fetchingState.LOADED)
        .setIn(
          ['appraisers', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        );
    }
    case appealsActions.FETCH_APPRAISERS[ERROR]: {
      return state.setIn(['appraisers', 'state'], fetchingState.ERROR);
    }

    case appealsActions.FETCH_USERS[START]: {
      return state.setIn(['users', 'state'], fetchingState.FETCHING);
    }
    case appealsActions.FETCH_USERS[SUCCESS]: {
      return state
        .setIn(['users', 'state'], fetchingState.LOADED)
        .setIn(['users', 'data'], fromJS(_.get(action, 'data.results', [])));
    }
    case appealsActions.FETCH_USERS[ERROR]: {
      return state.setIn(['users', 'state'], fetchingState.ERROR);
    }

    case appealsActions.FETCH_APPEALS_HEADER[START]: {
      return state.setIn(['appealsHeader', 'state'], fetchingState.FETCHING);
    }
    case appealsActions.FETCH_APPEALS_HEADER[SUCCESS]: {
      return state
        .setIn(['appealsHeader', 'state'], fetchingState.LOADED)
        .setIn(
          ['appealsHeader', 'data'],
          fromJS(_.get(action, 'data.results[0]', {})),
        );
    }
    case appealsActions.FETCH_APPEALS_HEADER[ERROR]: {
      return state.setIn(['appealsHeader', 'state'], fetchingState.ERROR);
    }

    case appealsActions.FETCH_APPEAL_GENERAL_INFO[START]: {
      return state.setIn(
        ['appealGeneralInfo', 'state'],
        fetchingState.FETCHING,
      );
    }
    case appealsActions.FETCH_APPEAL_GENERAL_INFO[SUCCESS]: {
      return state
        .setIn(['appealGeneralInfo', 'state'], fetchingState.LOADED)
        .setIn(
          ['appealGeneralInfo', 'data'],
          fromJS(_.get(action, 'data.results[0]', {})),
        );
    }
    case appealsActions.FETCH_APPEAL_GENERAL_INFO[ERROR]: {
      return state.setIn(['appealGeneralInfo', 'state'], fetchingState.ERROR);
    }

    case appealsActions.FETCH_APPEAL_GENERAL_INFO_NO_REFRESH[SUCCESS]: {
      return state.setIn(
        ['appealGeneralInfo', 'data', 'pRollCorr'],
        _.get(action, 'data.results[0].pRollCorr'),
      );
    }

    case appealsActions.FETCH_APPEALS_SUMMARY[START]: {
      return state.setIn(['appealsSummary', 'state'], fetchingState.FETCHING);
    }
    case appealsActions.FETCH_APPEALS_SUMMARY[SUCCESS]: {
      return state
        .setIn(['appealsSummary', 'state'], fetchingState.LOADED)
        .setIn(
          ['appealsSummary', 'data'],
          fromJS(_.get(action, 'data.results[0]', {})),
        );
    }
    case appealsActions.FETCH_APPEALS_SUMMARY[ERROR]: {
      return state.setIn(['appealsSummary', 'state'], fetchingState.ERROR);
    }

    case appealsActions.FETCH_APPEALS_SUMMARY_NO_REFRESH[SUCCESS]: {
      return state.setIn(
        ['appealsSummary', 'data', 'pRollCorr'],
        _.get(action, 'data.results[0].pRollCorr'),
      );
    }

    case appealsActions.REINITIALIZE_APPEAL_SUMMARY[SUCCESS]: {
      return state
        .setIn(
          ['appealsSummary', 'data'],
          fromJS({
            ...state.getIn(['appealsSummary', 'data']).toJS(),
            ..._.get(action, 'data.results[0]', {}),
          }),
        )
        .setIn(
          ['appealGeneralInfo', 'data'],
          fromJS({
            ...state.getIn(['appealGeneralInfo', 'data']).toJS(),
            ..._.get(action, 'data.results[0]', {}),
          }),
        );
    }

    case appealsActions.UPDATE_APPEALS_SUMMARY[SUCCESS]:
      return state.setIn(
        ['appealsSummary', 'data'],
        fromJS(_.get(action, 'data.results[0]', {})),
      );

    case appealsActions.UPDATE_APPEAL_GENERAL_INFO[SUCCESS]:
      return state.setIn(
        ['appealGeneralInfo', 'data'],
        fromJS(_.get(action, 'data.results[0]', {})),
      );

    case appealsActions.FETCH_APPEAL_REASONS[START]: {
      return state
        .setIn(['appealReasons', 'state'], fetchingState.FETCHING)
        .setIn(['appealReasons', 'data'], fromJS({}));
    }
    case appealsActions.FETCH_APPEAL_REASONS[SUCCESS]: {
      return state
        .setIn(['appealReasons', 'state'], fetchingState.LOADED)
        .setIn(
          ['appealReasons', 'data'],
          fromJS(_.get(action, 'data.results[0]', {})),
        );
    }
    case appealsActions.FETCH_APPEAL_REASONS[ERROR]: {
      return state.setIn(['appealReasons', 'state'], fetchingState.ERROR);
    }

    case appealsActions.UPDATE_APPEAL_REASONS[SUCCESS]:
      return state.setIn(
        ['appealReasons', 'data'],
        fromJS(_.get(action, 'data.results[0]', {})),
      );

    case appealsActions.FETCH_APPEAL_TAGS[START]: {
      return state.setIn(['appealTags', 'state'], fetchingState.FETCHING);
    }
    case appealsActions.FETCH_APPEAL_TAGS[SUCCESS]: {
      return state
        .setIn(['appealTags', 'state'], fetchingState.LOADED)
        .setIn(
          ['appealTags', 'data'],
          fromJS(_.get(action, 'data.results[0]', {})),
        );
    }
    case appealsActions.FETCH_APPEAL_TAGS[ERROR]: {
      return state.setIn(['appealTags', 'state'], fetchingState.ERROR);
    }

    case appealsActions.UPDATE_APPEAL_TAGS[SUCCESS]:
      return state.setIn(
        ['appealTags', 'data'],
        fromJS(_.get(action, 'data.results[0]', {})),
      );

    case appealsActions.FETCH_CLAIMANT_INFO[START]: {
      return state.setIn(['claimant', 'state'], fetchingState.FETCHING);
    }
    case appealsActions.FETCH_CLAIMANT_INFO[SUCCESS]: {
      return state
        .setIn(['claimant', 'state'], fetchingState.LOADED)
        .setIn(
          ['claimant', 'data'],
          fromJS(_.get(action, 'data.results[0]', {})),
        );
    }
    case appealsActions.FETCH_CLAIMANT_INFO[ERROR]: {
      return state.setIn(['dueDiligence', 'state'], fetchingState.ERROR);
    }

    case appealsActions.FETCH_AFFIDAVIT_INFO[START]: {
      return state.setIn(['affidavits', 'state'], fetchingState.FETCHING);
    }
    case appealsActions.FETCH_AFFIDAVIT_INFO[SUCCESS]: {
      return state
        .setIn(['affidavits', 'state'], fetchingState.LOADED)
        .setIn(
          ['affidavits', 'data'],
          fromJS(_.get(action, 'data.results[0]', {})),
        );
    }
    case appealsActions.FETCH_AFFIDAVIT_INFO[ERROR]: {
      return state.setIn(['affidavits', 'state'], fetchingState.ERROR);
    }

    case appealsActions.INSERT_FILE[SUCCESS]:
    case appealsActions.DELETE_FILE[SUCCESS]:
      return state
        .setIn([action.type, 'state'], fetchingState.LOADED)
        .setIn(
          [action.typeName, 'data'],
          fromJS(_.get(action, 'data.results[0]', {})),
        );

    case appealsActions.FETCH_DUE_DILIGENCE[START]: {
      return state
        .setIn(['dueDiligence', 'state'], fetchingState.FETCHING)
        .setIn(['dueDiligence', 'data'], fromJS({}));
    }
    case appealsActions.UPDATE_DUE_DILIGENCE[SUCCESS]:
    case appealsActions.FETCH_DUE_DILIGENCE[SUCCESS]: {
      return state
        .setIn(['dueDiligence', 'state'], fetchingState.LOADED)
        .setIn(
          ['dueDiligence', 'data'],
          fromJS(_.get(action, 'data.results[0]', {})),
        )
        .setIn(
          ['appealsSummary', 'data', 'updateDt'],
          _.get(action, 'data.results[0].updateDt'),
        )
        .setIn(
          ['appealGeneralInfo', 'data', 'updateDt'],
          _.get(action, 'data.results[0].updateDt'),
        );
    }
    case appealsActions.FETCH_DUE_DILIGENCE[ERROR]: {
      return state.setIn(['dueDiligence', 'state'], fetchingState.ERROR);
    }

    case appealsActions.FETCH_INFORMAL[START]: {
      return state.setIn(['informal', 'state'], fetchingState.FETCHING);
    }
    case appealsActions.UPDATE_INFORMAL[SUCCESS]:
    case appealsActions.START_INFORMAL[SUCCESS]:
    case appealsActions.FINISH_INFORMAL[SUCCESS]:
    case appealsActions.FETCH_INFORMAL[SUCCESS]: {
      return state
        .setIn(['informal', 'state'], fetchingState.LOADED)
        .setIn(
          ['informal', 'data'],
          fromJS(_.get(action, 'data.results[0]', {})),
        )
        .setIn(
          ['appealsSummary', 'data', 'updateDt'],
          _.get(action, 'data.results[0].updateDt'),
        )
        .setIn(
          ['appealGeneralInfo', 'data', 'updateDt'],
          _.get(action, 'data.results[0].updateDt'),
        );
    }
    case appealsActions.FETCH_INFORMAL[ERROR]: {
      return state.setIn(['informal', 'state'], fetchingState.ERROR);
    }

    case appealsActions.FETCH_PRIOR_YR_COMMENTS[START]: {
      return state.setIn(['priorYrComments', 'state'], fetchingState.FETCHING);
    }
    case appealsActions.FETCH_PRIOR_YR_COMMENTS[SUCCESS]: {
      return state
        .setIn(['priorYrComments', 'state'], fetchingState.LOADED)
        .setIn(
          ['priorYrComments', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        );
    }
    case appealsActions.FETCH_PRIOR_YR_COMMENTS[ERROR]: {
      return state.setIn(['priorYrComments', 'state'], fetchingState.ERROR);
    }

    case appealsActions.FETCH_FORMAL[START]: {
      return state.setIn(['formal', 'state'], fetchingState.FETCHING);
    }
    case appealsActions.PATCH_FORMAL[SUCCESS]:
    case appealsActions.UPDATE_FORMAL[SUCCESS]:
    case appealsActions.START_FORMAL[SUCCESS]:
    case appealsActions.FINISH_FORMAL[SUCCESS]:
    case appealsActions.FETCH_FORMAL[SUCCESS]: {
      return state
        .setIn(['formal', 'state'], fetchingState.LOADED)
        .setIn(['formal', 'data'], fromJS(_.get(action, 'data.results[0]', {})))
        .setIn(
          ['appealsSummary', 'data', 'updateDt'],
          _.get(action, 'data.results[0].updateDt'),
        )
        .setIn(
          ['appealGeneralInfo', 'data', 'updateDt'],
          _.get(action, 'data.results[0].updateDt'),
        );
    }
    case appealsActions.FETCH_FORMAL[ERROR]: {
      return state.setIn(['formal', 'state'], fetchingState.ERROR);
    }

    case appealsActions.FETCH_FINAL_VALUES[START]: {
      return state.setIn(['finalValues', 'state'], fetchingState.FETCHING);
    }
    case appealsActions.FINALIZE_FINAL_VALUES[SUCCESS]:
    case appealsActions.UPDATE_FINAL_VALUES[SUCCESS]:
    case appealsActions.FETCH_FINAL_VALUES[SUCCESS]: {
      return state
        .setIn(['finalValues', 'state'], fetchingState.LOADED)
        .setIn(
          ['finalValues', 'data'],
          fromJS(_.get(action, 'data.results[0]', {})),
        )
        .setIn(
          ['appealsSummary', 'data', 'updateDt'],
          _.get(action, 'data.results[0].updateDt'),
        )
        .setIn(
          ['appealGeneralInfo', 'data', 'updateDt'],
          _.get(action, 'data.results[0].updateDt'),
        );
    }
    case appealsActions.FETCH_FINAL_VALUES[ERROR]: {
      return state.setIn(['finalValues', 'state'], fetchingState.ERROR);
    }

    case appealsActions.FETCH_GLOBAL_DOCUMENTS[START]: {
      return state.setIn(['globalDocuments', 'state'], fetchingState.FETCHING);
    }
    case appealsActions.FETCH_GLOBAL_DOCUMENTS[SUCCESS]: {
      return state
        .setIn(['globalDocuments', 'state'], fetchingState.LOADED)
        .setIn(
          ['globalDocuments', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        );
    }
    case appealsActions.FETCH_GLOBAL_DOCUMENTS[ERROR]: {
      return state.setIn(['globalDocuments', 'state'], fetchingState.ERROR);
    }

    case appealsActions.FETCH_PRESENTATION_DOCUMENTS[START]: {
      return state.setIn(
        ['presentationDocuments', 'state'],
        fetchingState.FETCHING,
      );
    }
    case appealsActions.SET_PRESENTATION_ORDER[SUCCESS]:
    case appealsActions.FETCH_PRESENTATION_DOCUMENTS[SUCCESS]: {
      return state
        .setIn(['presentationDocuments', 'state'], fetchingState.LOADED)
        .setIn(
          ['presentationDocuments', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        );
    }
    case appealsActions.FETCH_PRESENTATION_DOCUMENTS[ERROR]: {
      return state.setIn(
        ['presentationDocuments', 'state'],
        fetchingState.ERROR,
      );
    }

    case appealsActions.DELETE_PRESENTATION_DOCUMENT[SUCCESS]:
      return state.setIn(
        ['presentationDocuments', 'data'],
        fromJS([
          ...state
            .getIn(['presentationDocuments', 'data'])
            .toJS()
            .filter((d) => d.documentID !== action.documentId),
        ]),
      );

    case appealsActions.INSERT_PRESENTATION_DOCUMENT[SUCCESS]:
      return state.setIn(
        ['presentationDocuments', 'data'],
        fromJS([
          ...state.getIn(['presentationDocuments', 'data']).toJS(),
          _.get(action, 'data.results[0]', []),
        ]),
      );

    case appealsActions.INSERT_PRESENTATION_DOCUMENT_GENERATE[SUCCESS]:
      return state.setIn(
        ['presentationDocuments', 'data'],
        fromJS([
          ...state.getIn(['presentationDocuments', 'data']).toJS(),
          _.get(action, 'data.results[0]', []),
        ]),
      );

    case appealsActions.FETCH_APPEAL_PRESENTATION[START]: {
      return state.setIn(
        ['appealPresentation', 'state'],
        fetchingState.FETCHING,
      );
    }
    case appealsActions.PUBLISH_APPEAL_PRESENTATION[SUCCESS]:
    case appealsActions.DELETE_APPEAL_PRESENTATION[SUCCESS]:
    case appealsActions.FETCH_APPEAL_PRESENTATION[SUCCESS]: {
      return state
        .setIn(['appealPresentation', 'state'], fetchingState.LOADED)
        .setIn(
          ['appealPresentation', 'data'],
          fromJS(_.get(action, 'data.results[0]', {})),
        );
    }
    case appealsActions.FETCH_APPEAL_PRESENTATION[ERROR]: {
      return state.setIn(['appealPresentation', 'state'], fetchingState.ERROR);
    }

    case appealsActions.FETCH_APPEAL_STAFF[START]: {
      return state.setIn(['appealStaff', 'state'], fetchingState.FETCHING);
    }
    case appealsActions.FETCH_APPEAL_STAFF[SUCCESS]: {
      return state
        .setIn(['appealStaff', 'state'], fetchingState.LOADED)
        .setIn(
          ['appealStaff', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        );
    }
    case appealsActions.FETCH_APPEAL_STAFF[ERROR]: {
      return state.setIn(['appealStaff', 'state'], fetchingState.ERROR);
    }

    case appealsActions.INSERT_APPEALS_STAFF[SUCCESS]:
      return state.setIn(
        ['appealStaff', 'data'],
        fromJS([
          ...state.getIn(['appealStaff', 'data']).toJS(),
          _.get(action, 'data.results[0]'),
        ]),
      );

    case appealsActions.DELETE_APPEALS_STAFF[SUCCESS]:
      return state.setIn(
        ['appealStaff', 'data'],
        fromJS([
          ...state
            .getIn(['appealStaff', 'data'])
            .toJS()
            .filter((d) => d.staffID !== action.staffId),
        ]),
      );

    case appealsActions.FETCH_APPEAL_DOCUMENTS[START]: {
      return state.setIn(['appealDocuments', 'state'], fetchingState.FETCHING);
    }

    case appealsActions.INSERT_APPEAL_DOC_FILE[SUCCESS]:
    case appealsActions.DELETE_APPEAL_DOC_FILE[SUCCESS]:
    case appealsActions.FETCH_APPEAL_DOCUMENTS[SUCCESS]: {
      return state
        .setIn(['appealDocuments', 'state'], fetchingState.LOADED)
        .setIn(
          ['appealDocuments', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        );
    }
    case appealsActions.FETCH_APPEAL_DOCUMENTS[ERROR]: {
      return state.setIn(['appealDocuments', 'state'], fetchingState.ERROR);
    }

    case appealsActions.INSERT_APPEAL_DOCUMENT[SUCCESS]:
      return state.setIn(
        ['appealDocuments', 'data'],
        fromJS([
          ...state.getIn(['appealDocuments', 'data']).toJS(),
          _.get(action, 'data.results[0]'),
        ]),
      );

    case appealsActions.UPDATE_APPEAL_DOCUMENT[SUCCESS]:
      return updateStateArrayItem(
        state,
        action,
        'appealDocuments',
        'documentID',
      );

    case appealsActions.DELETE_APPEAL_DOCUMENT[SUCCESS]:
      return state.setIn(
        ['appealDocuments', 'data'],
        fromJS([
          ...state
            .getIn(['appealDocuments', 'data'])
            .toJS()
            .filter((d) => d.documentID !== action.documentId),
        ]),
      );

    case appealsActions.INSERT_APPEAL[SUCCESS]: {
      return state
        .setIn(['newInsertedAppeal', 'state'], fetchingState.LOADED)
        .setIn(
          ['newInsertedAppeal', 'data'],
          fromJS(_.get(action, 'data.results[0]', {})),
        );
    }

    case appealsActions.FETCH_APPEAL_CASE_PREP[START]: {
      return state.setIn(['casePrep', 'state'], fetchingState.FETCHING);
    }
    case appealsActions.FETCH_APPEAL_CASE_PREP[SUCCESS]: {
      return state
        .setIn(['casePrep', 'state'], fetchingState.LOADED)
        .setIn(
          ['casePrep', 'data'],
          fromJS(_.get(action, 'data.results[0]', {})),
        );
    }
    case appealsActions.FETCH_APPEAL_CASE_PREP[ERROR]: {
      return state.setIn(['casePrep', 'state'], fetchingState.ERROR);
    }

    case appealsActions.UPDATE_APPEAL_CASE_PREP[START]: {
      return state.setIn(['casePrep', 'state'], fetchingState.FETCHING);
    }
    case appealsActions.UPDATE_APPEAL_CASE_PREP[SUCCESS]: {
      return state
        .setIn(['casePrep', 'state'], fetchingState.LOADED)
        .setIn(
          ['casePrep', 'data'],
          fromJS(_.get(action, 'data.results[0]', {})),
        )
        .setIn(
          ['appealsSummary', 'data', 'updateDt'],
          _.get(action, 'data.results[0].updateDt'),
        )
        .setIn(
          ['appealGeneralInfo', 'data', 'updateDt'],
          _.get(action, 'data.results[0].updateDt'),
        );
    }
    case appealsActions.UPDATE_APPEAL_CASE_PREP[ERROR]: {
      return state.setIn(['casePrep', 'state'], fetchingState.ERROR);
    }

    case appealsActions.FETCH_APPEAL_PANELS[START]: {
      return state.setIn(['panels', 'state'], fetchingState.FETCHING);
    }
    case appealsActions.FETCH_APPEAL_PANELS[SUCCESS]: {
      return state
        .setIn(['panels', 'state'], fetchingState.LOADED)
        .setIn(['panels', 'data'], fromJS(_.get(action, 'data.results', [])));
    }
    case appealsActions.FETCH_APPEAL_PANELS[ERROR]: {
      return state.setIn(['panels', 'state'], fetchingState.ERROR);
    }

    case appealsActions.FETCH_PANEL_BOARD_MEMBERS[START]: {
      return state.setIn(
        ['panelBoardMembers', 'state'],
        fetchingState.FETCHING,
      );
    }
    case appealsActions.FETCH_PANEL_BOARD_MEMBERS[SUCCESS]: {
      return state
        .setIn(['panelBoardMembers', 'state'], fetchingState.LOADED)
        .setIn(
          ['panelBoardMembers', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        );
    }
    case appealsActions.FETCH_PANEL_BOARD_MEMBERS[ERROR]: {
      return state.setIn(['panelBoardMembers', 'state'], fetchingState.ERROR);
    }

    case appealsActions.FETCH_ACTIVITY[START]: {
      return state.setIn(['activity', 'state'], fetchingState.FETCHING);
    }
    case appealsActions.FETCH_ACTIVITY[SUCCESS]: {
      return state
        .setIn(['activity', 'state'], fetchingState.LOADED)
        .setIn(['activity', 'data'], fromJS(_.get(action, 'data.results', [])));
    }
    case appealsActions.FETCH_ACTIVITY[ERROR]: {
      return state.setIn(['activity', 'state'], fetchingState.ERROR);
    }

    case appealsActions.FETCH_APPEAL_BOARD_MEMBERS[START]: {
      return state.setIn(
        ['appealBoardMembers', 'state'],
        fetchingState.FETCHING,
      );
    }
    case appealsActions.FETCH_APPEAL_BOARD_MEMBERS[SUCCESS]: {
      return state
        .setIn(['appealBoardMembers', 'state'], fetchingState.LOADED)
        .setIn(
          ['appealBoardMembers', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        );
    }
    case appealsActions.FETCH_APPEAL_BOARD_MEMBERS[ERROR]: {
      return state.setIn(['appealBoardMembers', 'state'], fetchingState.ERROR);
    }
    case appealsActions.DELETE_APPEAL_BOARD_MEMBER[SUCCESS]: {
      return state.setIn(
        ['appealBoardMembers', 'data'],
        fromJS(
          state
            .getIn(['appealBoardMembers', 'data'])
            .toJS()
            .filter((u) => u.boardMemberID !== action.boardMemberId),
        ),
      );
    }

    case appealsActions.FETCH_APPEAL_BOARD_MEMBER[START]: {
      return state.setIn(
        ['appealBoardMember', 'state'],
        fetchingState.FETCHING,
      );
    }
    case appealsActions.FETCH_APPEAL_BOARD_MEMBER[SUCCESS]: {
      return state
        .setIn(['appealBoardMember', 'state'], fetchingState.LOADED)
        .setIn(
          ['appealBoardMember', 'data'],
          fromJS(_.get(action, 'data.results.0', {})),
        );
    }
    case appealsActions.FETCH_APPEAL_BOARD_MEMBER[ERROR]: {
      return state.setIn(['appealBoardMember', 'state'], fetchingState.ERROR);
    }

    case appealsActions.FETCH_APPEAL_PANEL[START]: {
      return state.setIn(['panel', 'state'], fetchingState.FETCHING);
    }
    case appealsActions.FETCH_APPEAL_PANEL[SUCCESS]: {
      return state
        .setIn(['panel', 'state'], fetchingState.LOADED)
        .setIn(['panel', 'data'], fromJS(_.get(action, 'data.results.0', {})));
    }
    case appealsActions.FETCH_APPEAL_PANEL[ERROR]: {
      return state.setIn(['panel', 'state'], fetchingState.ERROR);
    }

    case appealsActions.CODE_FILE_OFFICER_POSITIONS[SUCCESS]: {
      return state
        .setIn(['codeFileOfficerPositions', 'state'], fetchingState.LOADED)
        .setIn(
          ['codeFileOfficerPositions', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        );
    }

    case appealsActions.CODE_FILE_ROLES[SUCCESS]: {
      return state
        .setIn(['codeFileRoles', 'state'], fetchingState.LOADED)
        .setIn(
          ['codeFileRoles', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        );
    }

    case appealsActions.CODE_FILE_PREFERRED_COMMUNICATION[SUCCESS]: {
      return state
        .setIn(
          ['codeFilePreferredCommunication', 'state'],
          fetchingState.LOADED,
        )
        .setIn(
          ['codeFilePreferredCommunication', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        );
    }

    case appealsActions.INSERT_APPEAL_BOARD_MEMBER[SUCCESS]: {
      return state.setIn(
        ['appealBoardMembers', 'data'],
        fromJS(
          state
            .getIn(['appealBoardMembers', 'data'])
            .toJS()
            .concat(_.get(action, ['data', 'results'], [])),
        ),
      );
    }

    case appealsActions.FETCH_APPEAL_PANEL_ROLES[SUCCESS]: {
      return state
        .setIn(['panelRoles', 'state'], fetchingState.LOADED)
        .setIn(
          ['panelRoles', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        );
    }

    case appealsActions.DELETE_APPEAL_PANEL[SUCCESS]: {
      return state.setIn(
        ['panels', 'data'],
        fromJS(
          state
            .getIn(['panels', 'data'])
            .toJS()
            .filter((u) => u.panelID !== action.panelID),
        ),
      );
    }

    case appealsActions.FETCH_APPEAL_PANEL_BOARD_MEMBER[START]: {
      return state.setIn(['panelBoardMember', 'state'], fetchingState.FETCHING);
    }
    case appealsActions.FETCH_APPEAL_PANEL_BOARD_MEMBER[SUCCESS]: {
      return state
        .setIn(['panelBoardMember', 'state'], fetchingState.LOADED)
        .setIn(
          ['panelBoardMember', 'data'],
          fromJS(_.get(action, 'data.results.0', {})),
        );
    }
    case appealsActions.FETCH_APPEAL_PANEL_BOARD_MEMBER[ERROR]: {
      return state.setIn(['panelBoardMember', 'state'], fetchingState.ERROR);
    }

    case appealsActions.DELETE_APPEAL_PANEL_BOARD_MEMBER[SUCCESS]: {
      return state.setIn(
        ['panelBoardMembers', 'data'],
        fromJS(
          state
            .getIn(['panelBoardMembers', 'data'])
            .toJS()
            .filter((u) => u.appealBoardMemberID !== action.appealMemberId),
        ),
      );
    }

    case appealsActions.FETCH_APPEAL_STAFF_ROLES[START]: {
      return state.setIn(['appealStaffRoles', 'state'], fetchingState.FETCHING);
    }
    case appealsActions.FETCH_APPEAL_STAFF_ROLES[SUCCESS]: {
      return state
        .setIn(['appealStaffRoles', 'state'], fetchingState.LOADED)
        .setIn(
          ['appealStaffRoles', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        );
    }
    case appealsActions.FETCH_APPEAL_STAFF_ROLES[ERROR]: {
      return state.setIn(['appealStaffRoles', 'state'], fetchingState.ERROR);
    }

    case appealsActions.FETCH_APPEAL_PANEL_CAD_STAFFS[START]: {
      return state.setIn(
        ['appealPanelCadStaffs', 'state'],
        fetchingState.FETCHING,
      );
    }
    case appealsActions.FETCH_APPEAL_PANEL_CAD_STAFFS[SUCCESS]: {
      return state
        .setIn(['appealPanelCadStaffs', 'state'], fetchingState.LOADED)
        .setIn(
          ['appealPanelCadStaffs', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        );
    }
    case appealsActions.FETCH_APPEAL_PANEL_CAD_STAFFS[ERROR]: {
      return state.setIn(
        ['appealPanelCadStaffs', 'state'],
        fetchingState.ERROR,
      );
    }

    case appealsActions.FETCH_APPEAL_PANEL_CAD_STAFF[START]: {
      return state.setIn(
        ['appealPanelCadStaff', 'state'],
        fetchingState.FETCHING,
      );
    }
    case appealsActions.FETCH_APPEAL_PANEL_CAD_STAFF[SUCCESS]: {
      return state
        .setIn(['appealPanelCadStaff', 'state'], fetchingState.LOADED)
        .setIn(
          ['appealPanelCadStaff', 'data'],
          fromJS(_.get(action, 'data.results.0', {})),
        );
    }
    case appealsActions.FETCH_APPEAL_PANEL_CAD_STAFF[ERROR]: {
      return state.setIn(['appealPanelCadStaff', 'state'], fetchingState.ERROR);
    }

    case appealsActions.INSERT_APPEAL_PANEL_CAD_STAFF[SUCCESS]: {
      return state.setIn(
        ['appealPanelCadStaffs', 'data'],
        fromJS(
          state
            .getIn(['appealPanelCadStaffs', 'data'])
            .toJS()
            .concat(_.get(action, ['data', 'results'], [])),
        ),
      );
    }

    case appealsActions.UPDATE_APPEAL_PANEL_CAD_STAFF[SUCCESS]: {
      const appealPanelCadStaffs = state
        .getIn(['appealPanelCadStaffs', 'data'])
        .toJS();
      const newAppealPanelCadStaffs = appealPanelCadStaffs.map((s) =>
        s.appealStaffID !== action.appealStaffId ? s : action.data.results[0],
      );
      return state
        .setIn(['appealPanelCadStaffs', 'state'], fetchingState.LOADED)
        .setIn(
          ['appealPanelCadStaffs', 'data'],
          fromJS(newAppealPanelCadStaffs),
        );
    }

    case appealsActions.DELETE_APPEAL_PANEL_CAD_STAFF[SUCCESS]: {
      return state.setIn(
        ['appealPanelCadStaffs', 'data'],
        fromJS(
          state
            .getIn(['appealPanelCadStaffs', 'data'])
            .toJS()
            .filter((u) => u.appealStaffID !== action.appealStaffId),
        ),
      );
    }

    case appealsActions.FETCH_APPEAL_DECISION_AUTHORITY[SUCCESS]: {
      return state
        .setIn(['appealDecisionAuthority', 'state'], fetchingState.LOADED)
        .setIn(
          ['appealDecisionAuthority', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        );
    }

    case appealsActions.FETCH_APPEAL_DECISION_CODE[SUCCESS]: {
      return state
        .setIn(['appealDecisionCode', 'state'], fetchingState.LOADED)
        .setIn(
          ['appealDecisionCode', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        );
    }

    case appealsActions.FETCH_APPEAL_DECISION_REASON[SUCCESS]: {
      return state
        .setIn(['appealDecisionReason', 'state'], fetchingState.LOADED)
        .setIn(
          ['appealDecisionReason', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        );
    }

    case appealsActions.FETCH_APPEAL_RECOMMENDATION_REASON[SUCCESS]: {
      return state
        .setIn(['appealRecommendationReason', 'state'], fetchingState.LOADED)
        .setIn(
          ['appealRecommendationReason', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        );
    }

    case appealsActions.APPEAL_SEARCH_PARAMS_FETCH[START]: {
      return state.setIn(['searchParams', 'state'], fetchingState.FETCHING);
    }
    case appealsActions.APPEAL_SEARCH_PARAMS_FETCH[SUCCESS]: {
      return state
        .setIn(['searchParams', 'state'], fetchingState.LOADED)
        .setIn(
          ['searchParams', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        );
    }
    case appealsActions.APPEAL_SEARCH_PARAMS_FETCH[ERROR]: {
      return state.setIn(['searchParam', 'state'], fetchingState.ERROR);
    }

    case appealsActions.APPEAL_SEARCH_PARAM_FETCH[START]: {
      return state.setIn(['searchParam', 'state'], fetchingState.FETCHING);
    }
    case appealsActions.APPEAL_SEARCH_PARAM_FETCH[SUCCESS]:
    case appealsActions.APPEAL_SEARCH_PARAM_INSERT[SUCCESS]:
    case appealsActions.APPEAL_SEARCH_PARAM_UPDATE[SUCCESS]: {
      return state
        .setIn(['searchParam', 'state'], fetchingState.LOADED)
        .setIn(
          ['searchParam', 'data'],
          fromJS(_.get(action, 'data.results.0', {})),
        );
    }
    case appealsActions.APPEAL_SEARCH_PARAM_FETCH[ERROR]: {
      return state.setIn(['searchParam', 'state'], fetchingState.ERROR);
    }

    case appealsActions.APPEAL_SEARCH_RESET: {
      return state
        .setIn(['appealsSearch', 'state'], fetchingState.LOADED)
        .setIn(
          ['appealsSearchLastPayload', 'data'],
          fromJS(initialState.appealsSearchLastPayload.data),
        )
        .setIn(
          ['appealsSearch', 'data'],
          fromJS(initialState.appealsSearch.data),
        )
        .setIn(['pagination'], fromJS(initialState.pagination));
    }

    case appealsActions.APPEAL_SEARCH_PARAM_RESET: {
      return state.setIn(['searchParam', 'data'], fromJS({}));
    }

    case appealsActions.APPEAL_SEARCH_PARAM_SET: {
      return state.setIn(['appealsSearch', 'state'], null).setIn(
        ['searchParam', 'data'],
        fromJS(
          state
            .getIn(['searchParams', 'data'])
            .toJS()
            .find((v) => v.searchParamID === action.searchParamID),
        ),
      );
    }
    case appealsActions.FETCH_APPEAL_RECOMMENDATIONS[START]: {
      return state.setIn(
        ['appealRecommendations', 'state'],
        fetchingState.FETCHING,
      );
    }
    case appealsActions.FETCH_APPEAL_RECOMMENDATIONS[SUCCESS]: {
      return state
        .setIn(['appealRecommendations', 'state'], fetchingState.LOADED)
        .setIn(
          ['appealRecommendations', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        );
    }
    case appealsActions.FETCH_APPEAL_RECOMMENDATIONS[ERROR]: {
      return state.setIn(
        ['appealRecommendations', 'state'],
        fetchingState.ERROR,
      );
    }

    case appealsActions.FETCH_RECOMMENDATION_VALUES[SUCCESS]: {
      return state
        .setIn(['recommendationValues', 'state'], fetchingState.LOADED)
        .setIn(
          ['recommendationValues', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        );
    }

    case appealsActions.INSERT_RECOMMENDATION[SUCCESS]: {
      return state.setIn(
        ['appealRecommendations', 'data'],
        fromJS([
          ...state.getIn(['appealRecommendations', 'data']).toJS(),
          _.get(action, 'data.results[0]'),
        ]),
      );
    }

    case appealsActions.FETCH_RECOMMENDATION[START]: {
      return state.setIn(
        ['appealRecommendation', 'state'],
        fetchingState.FETCHING,
      );
    }
    case appealsActions.FETCH_RECOMMENDATION[SUCCESS]:
    case appealsActions.INSERT_RECOMMENDATION_FILE[SUCCESS]:
    case appealsActions.UPDATE_RECOMMENDATION_FILE[SUCCESS]:
    case appealsActions.DELETE_RECOMMENDATION_FILE[SUCCESS]: {
      return state
        .setIn(['appealRecommendation', 'state'], fetchingState.LOADED)
        .setIn(
          ['appealRecommendation', 'data'],
          fromJS(_.get(action, 'data.results.0', {})),
        );
    }
    case appealsActions.FETCH_RECOMMENDATION[ERROR]: {
      return state.setIn(
        ['appealRecommendation', 'state'],
        fetchingState.ERROR,
      );
    }
    case appealsActions.SET_PRINT_CARD_DATA: {
      return state.setIn(['printCard', 'data'], fromJS(action.windowData));
    }

    case appealsActions.FETCH_STATUS_CODES[START]: {
      return state.setIn(['statusCodes', 'state'], fetchingState.FETCHING);
    }
    case appealsActions.FETCH_STATUS_CODES[SUCCESS]: {
      return state
        .setIn(['statusCodes', 'state'], fetchingState.LOADED)
        .setIn(
          ['statusCodes', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        );
    }
    case appealsActions.FETCH_STATUS_CODES[ERROR]: {
      return state.setIn(['statusCodes', 'state'], fetchingState.ERROR);
    }

    case appealsActions.DELETE_STATUS_CODE[SUCCESS]:
      return state.setIn(
        ['statusCodes', 'data'],
        fromJS([
          ...state
            .getIn(['statusCodes', 'data'])
            .toJS()
            .filter(
              (s) => s.appealStatus !== base64.decode(action.appealStatus),
            ),
        ]),
      );

    case appealsActions.APPEAL_STATUS_CONFIG_STATE[SUCCESS]: {
      return state
        .setIn(['appealStatusConfigState', 'state'], fetchingState.LOADED)
        .setIn(
          ['appealStatusConfigState', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        );
    }

    case appealsActions.APPEAL_MODULE_REPORTS[SUCCESS]: {
      return state
        .setIn(['appealModuleReports', 'state'], fetchingState.LOADED)
        .setIn(
          ['appealModuleReports', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        );
    }

    case appealsActions.FETCH_APPEAL_STATUS[START]: {
      return state.setIn(['appealStatus', 'state'], fetchingState.FETCHING);
    }
    case appealsActions.FETCH_APPEAL_STATUS[SUCCESS]: {
      return state
        .setIn(['appealStatus', 'state'], fetchingState.LOADED)
        .setIn(
          ['appealStatus', 'data'],
          fromJS(_.get(action, 'data.results.0', {})),
        );
    }
    case appealsActions.FETCH_APPEAL_STATUS[ERROR]: {
      return state.setIn(['appealStatus', 'state'], fetchingState.ERROR);
    }

    case appealsActions.INSERT_APPEAL_STATUS_CONFIG[SUCCESS]: {
      return state.setIn(
        ['statusCodes', 'data'],
        fromJS(
          state
            .getIn(['statusCodes', 'data'])
            .toJS()
            .concat(_.get(action, ['data', 'results'], [])),
        ),
      );
    }

    case appealsActions.UPDATE_APPEAL_STATUS_CONFIG[SUCCESS]:
      return updateStateArrayItem(state, action, 'statusCodes', 'appealStatus');

    case appealsActions.FETCH_FINAL_LETTER_HISTORY[START]: {
      return state.setIn(
        ['finalLetterHistory', 'state'],
        fetchingState.FETCHING,
      );
    }
    case appealsActions.FETCH_FINAL_LETTER_HISTORY[SUCCESS]: {
      return state
        .setIn(['finalLetterHistory', 'state'], fetchingState.LOADED)
        .setIn(
          ['finalLetterHistory', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        )
        .setIn(
          ['finalLetterHistory', 'totalRecords'],
          _.get(action, 'data.totalRecords', 0),
        );
    }
    case appealsActions.FETCH_FINAL_LETTER_HISTORY[ERROR]: {
      return state.setIn(['finalLetterHistory', 'state'], fetchingState.ERROR);
    }

    case appealsActions.FETCH_MASS_FINALIZE_HISTORY[START]: {
      return state.setIn(
        ['massFinalizeHistory', 'state'],
        fetchingState.FETCHING,
      );
    }
    case appealsActions.FETCH_MASS_FINALIZE_HISTORY[SUCCESS]: {
      return state
        .setIn(['massFinalizeHistory', 'state'], fetchingState.LOADED)
        .setIn(
          ['massFinalizeHistory', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        )
        .setIn(
          ['massFinalizeHistory', 'totalRecords'],
          _.get(action, 'data.totalRecords', 0),
        );
    }
    case appealsActions.FETCH_MASS_FINALIZE_HISTORY[ERROR]: {
      return state.setIn(['massFinalizeHistory', 'state'], fetchingState.ERROR);
    }

    case appealsActions.FETCH_AUTO_PACKET_STATUS[START]: {
      return state.setIn(['autoPacketStatus', 'state'], fetchingState.FETCHING);
    }
    case appealsActions.FETCH_AUTO_PACKET_STATUS[SUCCESS]: {
      return state
        .setIn(['autoPacketStatus', 'state'], fetchingState.LOADED)
        .setIn(
          ['autoPacketStatus', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        );
    }
    case appealsActions.FETCH_AUTO_PACKET_STATUS[ERROR]: {
      return state.setIn(['autoPacketStatus', 'state'], fetchingState.ERROR);
    }

    case appealsActions.FETCH_MASS_PROCESS_HISTORY[START]: {
      return state.setIn(
        ['massProcessHistory', 'state'],
        fetchingState.FETCHING,
      );
    }
    case appealsActions.FETCH_MASS_PROCESS_HISTORY[SUCCESS]: {
      return state
        .setIn(['massProcessHistory', 'state'], fetchingState.LOADED)
        .setIn(
          ['massProcessHistory', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        )
        .setIn(
          ['massProcessHistory', 'totalRecords'],
          _.get(action, 'data.totalRecords', 0),
        );
    }
    case appealsActions.FETCH_MASS_PROCESS_HISTORY[ERROR]: {
      return state.setIn(['massProcessHistory', 'state'], fetchingState.ERROR);
    }
    case appealsActions.FETCH_MASS_PROCESS_ENTRIES[START]: {
      return state.setIn(
        ['massProcessEntries', 'state'],
        fetchingState.FETCHING,
      );
    }
    case appealsActions.FETCH_MASS_PROCESS_ENTRIES[SUCCESS]: {
      return state
        .setIn(['massProcessEntries', 'state'], fetchingState.LOADED)
        .setIn(
          ['massProcessEntries', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        );
    }
    case appealsActions.FETCH_MASS_PROCESS_ENTRIES[ERROR]: {
      return state.setIn(['massProcessEntries', 'state'], fetchingState.ERROR);
    }

    case appealsActions.FETCH_MASS_APPEAL_LETTER_HISTORY[START]: {
      return state.setIn(
        ['massAppealLetterHistory', 'state'],
        fetchingState.FETCHING,
      );
    }
    case appealsActions.FETCH_MASS_APPEAL_LETTER_HISTORY[SUCCESS]: {
      return state
        .setIn(['massAppealLetterHistory', 'state'], fetchingState.LOADED)
        .setIn(
          ['massAppealLetterHistory', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        )
        .setIn(
          ['massAppealLetterHistory', 'totalRecords'],
          _.get(action, 'data.totalRecords', 0),
        );
    }
    case appealsActions.FETCH_MASS_APPEAL_LETTER_HISTORY[ERROR]: {
      return state.setIn(
        ['massAppealLetterHistory', 'state'],
        fetchingState.ERROR,
      );
    }

    case appealsActions.FETCH_MASS_ATTACH_HISTORY[START]: {
      return state.setIn(
        ['massAttachHistory', 'state'],
        fetchingState.FETCHING,
      );
    }
    case appealsActions.FETCH_MASS_ATTACH_HISTORY[SUCCESS]: {
      return state
        .setIn(['massAttachHistory', 'state'], fetchingState.LOADED)
        .setIn(
          ['massAttachHistory', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        )
        .setIn(
          ['massAttachHistory', 'totalRecords'],
          _.get(action, 'data.totalRecords', 0),
        );
    }
    case appealsActions.FETCH_MASS_ATTACH_HISTORY[ERROR]: {
      return state.setIn(['massAttachHistory', 'state'], fetchingState.ERROR);
    }

    case appealsActions.FETCH_EVIDENCE_UPLOAD_HISTORY[START]: {
      return state.setIn(
        ['evidenceUploadHistory', 'state'],
        fetchingState.FETCHING,
      );
    }
    case appealsActions.FETCH_EVIDENCE_UPLOAD_HISTORY[SUCCESS]: {
      return state
        .setIn(['evidenceUploadHistory', 'state'], fetchingState.LOADED)
        .setIn(
          ['evidenceUploadHistory', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        )
        .setIn(
          ['evidenceUploadHistory', 'totalRecords'],
          _.get(action, 'data.totalRecords', 0),
        );
    }
    case appealsActions.FETCH_EVIDENCE_UPLOAD_HISTORY[ERROR]: {
      return state.setIn(
        ['evidenceUploadHistory', 'state'],
        fetchingState.ERROR,
      );
    }

    case appealsActions.FETCH_EVIDENCE_IMPORT_PROPERTIES[START]: {
      return state.setIn(
        ['evidenceImportProperties', 'state'],
        fetchingState.FETCHING,
      );
    }
    case appealsActions.FETCH_EVIDENCE_IMPORT_PROPERTIES[SUCCESS]: {
      return state
        .setIn(['evidenceImportProperties', 'state'], fetchingState.LOADED)
        .setIn(
          ['evidenceImportProperties', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        );
    }
    case appealsActions.FETCH_EVIDENCE_IMPORT_PROPERTIES[ERROR]: {
      return state.setIn(
        ['evidenceImportProperties', 'state'],
        fetchingState.ERROR,
      );
    }

    case appealsActions.FETCH_MASS_DOWNLOAD_HISTORY[START]: {
      return state.setIn(
        ['massDownloadHistory', 'state'],
        fetchingState.FETCHING,
      );
    }
    case appealsActions.FETCH_MASS_DOWNLOAD_HISTORY[SUCCESS]: {
      return state
        .setIn(['massDownloadHistory', 'state'], fetchingState.LOADED)
        .setIn(
          ['massDownloadHistory', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        )
        .setIn(
          ['massDownloadHistory', 'totalRecords'],
          _.get(action, 'data.totalRecords', 0),
        );
    }
    case appealsActions.FETCH_MASS_DOWNLOAD_HISTORY[ERROR]: {
      return state.setIn(['massDownloadHistory', 'state'], fetchingState.ERROR);
    }

    case appealsActions.FETCH_MASS_AOA_HISTORY[START]: {
      return state.setIn(['massAoaHistory', 'state'], fetchingState.FETCHING);
    }
    case appealsActions.FETCH_MASS_AOA_HISTORY[SUCCESS]: {
      return state
        .setIn(['massAoaHistory', 'state'], fetchingState.LOADED)
        .setIn(
          ['massAoaHistory', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        )
        .setIn(
          ['massAoaHistory', 'totalRecords'],
          _.get(action, 'data.totalRecords', 0),
        );
    }
    case appealsActions.FETCH_MASS_AOA_HISTORY[ERROR]: {
      return state.setIn(['massAoaHistory', 'state'], fetchingState.ERROR);
    }

    case appealsActions.FETCH_MASS_AOA_PROPERTY_LIST[START]: {
      return state.setIn(['massProperties', 'state'], fetchingState.FETCHING);
    }
    case appealsActions.FETCH_MASS_AOA_PROPERTY_LIST[SUCCESS]: {
      return state
        .setIn(['massProperties', 'state'], fetchingState.LOADED)
        .setIn(
          ['massProperties', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        );
    }
    case appealsActions.FETCH_MASS_AOA_PROPERTY_LIST[ERROR]: {
      return state.setIn(['massProperties', 'state'], fetchingState.ERROR);
    }

    case appealsActions.REOPEN_APPEAL[SUCCESS]: {
      return state
        .setIn(
          ['appealsHeader', 'data'],
          fromJS({
            ...state.getIn(['appealsHeader', 'data']).toJS(),
            ..._.get(action, 'data.results.0', {}),
          }),
        )
        .setIn(
          ['appealsSummary', 'data'],
          fromJS({
            ...state.getIn(['appealsSummary', 'data']).toJS(),
            ..._.get(action, 'data.results.0', {}),
          }),
        )
        .setIn(
          ['appealGeneralInfo', 'data'],
          fromJS({
            ...state.getIn(['appealGeneralInfo', 'data']).toJS(),
            ..._.get(action, 'data.results.0', {}),
          }),
        );
    }

    // EVENTS
    case appealsActions.APPEAL_EVENTS_FETCH[START]: {
      return state
        .setIn(['events', 'data'], fromJS([]))
        .setIn(['events', 'state'], fetchingState.FETCHING);
    }
    case appealsActions.APPEAL_EVENTS_FETCH[SUCCESS]: {
      return state
        .setIn(['events', 'state'], fetchingState.LOADED)
        .setIn(['events', 'data'], fromJS(_.get(action, 'data.results', [])));
    }
    case appealsActions.APPEAL_EVENTS_FETCH[ERROR]: {
      return state.setIn(['events', 'state'], fetchingState.ERROR);
    }
    case appealsActions.APPEAL_EVENT_DELETE[SUCCESS]: {
      return state.setIn(
        ['events', 'data'],
        fromJS(
          state
            .getIn(['events', 'data'])
            .toJS()
            .filter((e) => e.appealID !== action.appealID),
        ),
      );
    }

    case appealsActions.APPEAL_FETCH_TAXING_UNITS[SUCCESS]: {
      return state.setIn(
        ['taxingUnits'],
        fromJS(_.get(action, 'data.results', [])),
      );
    }

    case appealsActions.FETCH_PANEL_DOCKET_GROUPS[START]: {
      return state.setIn(
        ['panelDocketGroups', 'state'],
        fetchingState.FETCHING,
      );
    }
    case appealsActions.FETCH_PANEL_DOCKET_GROUPS[SUCCESS]: {
      return state
        .setIn(['panelDocketGroups', 'state'], fetchingState.LOADED)
        .setIn(
          ['panelDocketGroups', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        );
    }
    case appealsActions.FETCH_PANEL_DOCKET_GROUPS[ERROR]: {
      return state.setIn(['panelDocketGroups', 'state'], fetchingState.ERROR);
    }

    case appealsActions.DELETE_PANEL_DOCKET_GROUPS[SUCCESS]: {
      return state.setIn(['panelDocketGroups', 'data'], fromJS([]));
    }

    case appealsActions.FETCH_PANEL_WAITING_ROOMS[START]: {
      return state.setIn(
        ['panelWaitingRooms', 'state'],
        fetchingState.FETCHING,
      );
    }
    case appealsActions.FETCH_PANEL_WAITING_ROOMS[SUCCESS]: {
      return state
        .setIn(['panelWaitingRooms', 'state'], fetchingState.LOADED)
        .setIn(
          ['panelWaitingRooms', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        );
    }
    case appealsActions.FETCH_PANEL_WAITING_ROOMS[ERROR]: {
      return state.setIn(['panelWaitingRooms', 'state'], fetchingState.ERROR);
    }

    case appealsActions.DELETE_PANEL_WAITING_ROOMS[SUCCESS]: {
      return state.setIn(['panelWaitingRooms', 'data'], fromJS([]));
    }

    case appealsActions.APPEAL_SET_SEARCH_FORM_DATA: {
      return state.setIn(['appealSearchFormData'], fromJS(action.payload));
    }
    case appealsActions.SET_SELECTED_INFORMAL_WAITING_ROOM: {
      return state.setIn(
        ['selectedInformalWaitingRoom'],
        fromJS(_.get(action, 'payload', null)),
      );
    }
    case appealsActions.CLEAR_SELECTED_INFORMAL_WAITING_ROOM: {
      return state.setIn(['selectedInformalWaitingRoom'], null);
    }
    case appealsActions.SET_SELECTED_FORMAL_WAITING_ROOM: {
      return state.setIn(
        ['selectedFormalWaitingRoom'],
        fromJS(_.get(action, 'payload', null)),
      );
    }
    case appealsActions.CLEAR_SELECTED_FORMAL_WAITING_ROOM: {
      return state.setIn(['selectedFormalWaitingRoom'], null);
    }
    case appealsActions.SET_SELECTED_PANEL_TYPE: {
      return state.setIn(
        ['selectedPanelType'],
        fromJS(_.get(action, 'payload', null)),
      );
    }
    case appealsActions.CLEAR_SELECTED_PANEL_TYPE: {
      return state.setIn(['selectedPanelType'], null);
    }

    case appealsActions.APPEAL_FETCH_CONFIGURATION_GENERAL[START]: {
      return state.setIn(
        ['appealConfiguration', 'state'],
        fetchingState.FETCHING,
      );
    }
    case appealsActions.APPEAL_FETCH_CONFIGURATION_GENERAL[SUCCESS]: {
      return state
        .setIn(['appealConfiguration', 'state'], fetchingState.LOADED)
        .setIn(
          ['appealConfiguration', 'data'],
          fromJS(_.get(action, 'data.results[0]', initialAppealConfiguration)),
        );
    }
    case appealsActions.APPEAL_FETCH_CONFIGURATION_GENERAL[ERROR]: {
      return state.setIn(['appealConfiguration', 'state'], fetchingState.ERROR);
    }

    case appealsActions.APPEAL_UPDATE_CONFIGURATION_GENERAL[START]: {
      return state.setIn(
        ['appealConfiguration', 'state'],
        fetchingState.FETCHING,
      );
    }
    case appealsActions.APPEAL_UPDATE_CONFIGURATION_GENERAL[SUCCESS]: {
      return state
        .setIn(['appealConfiguration', 'state'], fetchingState.LOADED)
        .setIn(
          ['appealConfiguration', 'data'],
          fromJS(_.get(action, 'data.results[0]', initialAppealConfiguration)),
        );
    }
    case appealsActions.APPEAL_UPDATE_CONFIGURATION_GENERAL[ERROR]: {
      return state.setIn(['appealConfiguration', 'state'], fetchingState.ERROR);
    }
    case appealsActions.FETCH_MASS_PROCESS_PROPERTY_LIST[START]: {
      return state.setIn(
        ['massProcessHistoryPropertyList', 'state'],
        fetchingState.FETCHING,
      );
    }
    case appealsActions.FETCH_MASS_PROCESS_PROPERTY_LIST[SUCCESS]: {
      return state
        .setIn(
          ['massProcessHistoryPropertyList', 'state'],
          fetchingState.LOADED,
        )
        .setIn(
          ['massProcessHistoryPropertyList', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        )
        .setIn(
          ['massProcessHistoryPropertyList', 'totalRecords'],
          _.get(action, 'data.totalRecords', 0),
        );
    }
    case appealsActions.FETCH_MASS_PROCESS_PROPERTY_LIST[ERROR]: {
      return state.setIn(
        ['massProcessHistoryPropertyList', 'state'],
        fetchingState.ERROR,
      );
    }
    case appealsActions.FETCH_MASS_PROCESS_ERRORS[START]: {
      return state.setIn(
        ['massProcessHistoryErrors', 'state'],
        fetchingState.FETCHING,
      );
    }
    case appealsActions.FETCH_MASS_PROCESS_ERRORS[SUCCESS]: {
      return state
        .setIn(['massProcessHistoryErrors', 'state'], fetchingState.LOADED)
        .setIn(
          ['massProcessHistoryErrors', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        )
        .setIn(
          ['massProcessHistoryErrors', 'totalRecords'],
          _.get(action, 'data.totalRecords', 0),
        );
    }
    case appealsActions.FETCH_MASS_PROCESS_ERRORS[ERROR]: {
      return state.setIn(
        ['massProcessHistoryErrors', 'state'],
        fetchingState.ERROR,
      );
    }
    case appealsActions.MASS_PROCESS_PROPERTY_LIST_RESET: {
      return state
        .setIn(
          ['massProcessHistoryPropertyList', 'state'],
          fetchingState.LOADED,
        )
        .setIn(['massProcessHistoryPropertyList', 'data'], fromJS([]))
        .setIn(['massProcessHistoryPropertyList', 'totalRecords'], 0);
    }
    case appealsActions.MASS_PROCESS_ERRORS_RESET: {
      return state
        .setIn(['massProcessHistoryErrors', 'state'], fetchingState.LOADED)
        .setIn(['massProcessHistoryErrors', 'data'], fromJS([]))
        .setIn(['massProcessHistoryErrors', 'totalRecords'], 0);
    }

    case appealsActions.FETCH_FORMAL_VC_RECORDINGS[START]: {
      return state.setIn(
        ['formalVCRecordings', 'state'],
        fetchingState.FETCHING,
      );
    }
    case appealsActions.FETCH_FORMAL_VC_RECORDINGS[SUCCESS]: {
      return state
        .setIn(['formalVCRecordings', 'state'], fetchingState.LOADED)
        .setIn(
          ['formalVCRecordings', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        );
    }
    case appealsActions.FETCH_FORMAL_VC_RECORDINGS[ERROR]: {
      return state.setIn(['formalVCRecordings', 'state'], fetchingState.ERROR);
    }

    default:
      return state;
  }
};
